module.exports = __webpack_public_path__ + "static/img/user_plan.fe19c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_plan.png
// module id = Ih/P
// module chunks = 0